import React from 'react'
import Wrapper from '../../components/wrapper'
import PropTypes from 'prop-types'
import './styles.css'
import Loader from '../../components/loader'

export class PoolScheduleCSVUpload extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      csv: this.props.csv || ''
    }
  }


  render() {
    const isCreateDisabled = this.props.isLoading || !this.state.csv || this.props.isActionDisabled
    const disabledClassName = this.props.isActionDisabled ? 'legacy-disabled-action' : ''
    let numberOfParseErrorsToDisplay = 10
    let parseErrors = this.props.csvParseErrors || []
    let parseErrorsToDisplay = parseErrors.slice(0,numberOfParseErrorsToDisplay)
    let numberOfParseErrorsHidden = parseErrors.length - numberOfParseErrorsToDisplay

    return <Wrapper title={'Pool Schedule'} >
      <div className="restaurant-pool-schedule pool-schedule-csv">
        <p>Paste in the <strong>restaurant IDs</strong>, <strong>pool names</strong> and <strong>start dates</strong> from a Google sheet (tab or comma separated values, 1 restaurant per line)</p>
        <textarea 
          wrap="off"
          className="csv-input" 
          disabled={this.props.isLoading}
          placeholder="76459&#9;Nottingham_Central&#9;21/05/2019"
          value={this.state.csv}
          onChange={ev=>this.setState({csv:ev.target.value})}/>

        {
          parseErrorsToDisplay.length > 0 
            ? <div className="alert alert-danger csv-parse-errors">
              <h5 className="alert-heading"><span className="fa fa-exclamation-triangle mr-3" />{parseErrorsToDisplay.length} problem{parseErrorsToDisplay.length > 1 ? 's' : ''} need{parseErrorsToDisplay.length === 1 ? 's' : ''} sorting out before you can continue</h5>
              <table>
                <tbody>
                  {parseErrorsToDisplay.map(csvError=>{
                    return <tr key={(csvError.row || 0) + '_' + csvError.code}>
                      <td className="line-number">line {(csvError.row || 0)+1}</td>
                      <td className="line-message">{csvError.message}</td>
                    </tr>
                  })}
                  {numberOfParseErrorsHidden > 0 
                    ? <tr>
                      <td className="line-number text-center">...</td>
                      <td className="more-errors">{numberOfParseErrorsHidden} more error{numberOfParseErrorsHidden > 1 ? "s" : null}</td>
                    </tr>
                    : null}
                </tbody>
              </table>
            </div>
            : null
        }

        <div className="edit-button-bar text-right">
          {this.props.isLoading ? <Loader/> : null}
          <button 
            disabled={this.props.isLoading}
            className="btn btn-sm btn-secondary mr-1"
            onClick={() => this.props.onBack()}>
              Cancel
          </button>
          <span title={this.props.disabledTitle}>
            <button
              id="btnCreateSchedules"
              className={`btn btn-sm btn-primary ${disabledClassName}`.trim()}
              onClick={() => this.props.onProcess(this.state.csv)}
              disabled={isCreateDisabled}>
                Create schedules
            </button>
          </span>
        </div>
      </div>
    </Wrapper>
  }
}

PoolScheduleCSVUpload.propTypes = {
  csv: PropTypes.string,
  csvParseErrors: PropTypes.array,
  isLoading: PropTypes.bool,
  isActionDisabled: PropTypes.bool,
  disabledTitle: PropTypes.string,

  onBack: PropTypes.func.isRequired,
  onProcess: PropTypes.func.isRequired
}

PoolScheduleCSVUpload.defaultProps = {
  isActionDisabled: false,
  disabledTitle: ''
}

export default PoolScheduleCSVUpload



// WEBPACK FOOTER //
// ./src/containers/restaurant-pool-schedule/RestaurantPoolScheduleCSVUpload.js